import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import CargoMarketLayout from "./CargoMarketLayout";
import {
  FUNCTIONALITIES,
  CARGO_MARKET_BASE,
  LEGACY_REDIRECTS,
  cargoMarketDefaultRoute,
} from "./config";

// Builds the nested route tree for /cargo-market from the nav config so the
// sub-menu and the routes never drift apart. One child route per sub-item, plus
// index redirects (section -> first functionality, functionality -> its
// dashboard) and the redirects of the retired auction screens.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={cargoMarketDefaultRoute} replace /> },
];

for (const f of FUNCTIONALITIES) {
  children.push({
    path: f.slug,
    element: <Navigate to={`${CARGO_MARKET_BASE}/${f.slug}/${f.menu[0].id}`} replace />,
  });
  for (const item of f.menu) {
    children.push({ path: `${f.slug}/${item.id}`, element: item.element });
  }
}

for (const [from, to] of Object.entries(LEGACY_REDIRECTS)) {
  children.push({ path: from, element: <Navigate to={`${CARGO_MARKET_BASE}/${to}`} replace /> });
}

export const cargoMarketRoute: RouteObject = {
  path: CARGO_MARKET_BASE,
  element: <CargoMarketLayout />,
  children,
};
